export default function AboutSection() {
  return (
    <section className="bg-background-100/80 py-20 md:py-24 px-4 md:px-6">
      <div className="max-w-[760px] mx-auto text-center">
        <span className="inline-block px-4 py-1.5 rounded-full border border-foreground-200/60 text-foreground-400 text-xs font-label font-medium tracking-wide uppercase">
          Почему выбирают YOYBUY Spreadsheet
        </span>

        <div className="mt-8 text-lg md:text-[22px] text-foreground-700 font-light leading-[1.75] space-y-6">
          <p>
            YOYBUY Spreadsheet — это революционный способ покупать товары из Китая. Вместо сложных приложений и запутанных интерфейсов, вы получаете простую и понятную таблицу, куда добавляете ссылки на понравившиеся товары с Taobao, Weidian, 1688 и других китайских маркетплейсов. Агент YOYBUY обрабатывает ваш заказ, проверяет качество, упаковывает и отправляет посылку прямо к вашей двери.
          </p>
          <p>
            В отличие от Kakobuy и Superbuy, YOYBUY Spreadsheet предлагает самые низкие комиссии на рынке, полную поддержку на русском языке и максимально быструю обработку заказов. Вы просто заполняете spreadsheet — всё остальное делает команда YOYBUY. Это идеальное решение для тех, кто ценит своё время и хочет покупать качественные вещи из Китая без лишних хлопот.
          </p>
          <p>
            Тысячи пользователей из России и стран СНГ уже выбрали YOYBUY Spreadsheet как основной инструмент для шоппинга. Присоединяйтесь к сообществу умных покупателей уже сегодня и откройте для себя мир китайской моды без границ и языковых барьеров.
          </p>
        </div>
      </div>
    </section>
  );
}